"use client";

import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight, Play } from "lucide-react";
import Image from "next/image";

const HeroSection = () => {
  const headerRef = useRef(null);
  const sectionRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start end", "end center"],
  });
  const headerMarginBottom = useTransform(scrollYProgress, [0, 0.5], [0, 80]);

  const rotateX = useTransform(scrollYProgress, [0, 0.5], [70, 0]);

  const scale = useTransform(scrollYProgress, [0, 0.5], [0.8, 1]);

  const y = useTransform(scrollYProgress, [0, 0.5], [-30, 0]);
  // <div className="w-full px-5 sm:px-6 lg:px-20 py- lg:py-0">
  //    style={{
  //       backgroundColor: "#ffffff",
  //       backgroundImage: `
  //   radial-gradient(
  //     60% 80% at 50% -10%,
  //     rgba(127, 161, 255, 0.2) 0%,
  //     rgba(127, 161, 255, 0) 60%
  //   ),
  //   repeating-linear-gradient(
  //     to right,
  //     rgba(102, 102, 102, 0.13) 0 1px,
  //     transparent 1px 76px
  //   ),
  //   repeating-linear-gradient(
  //     to bottom,
  //     rgba(102, 102, 102, 0.13) 0 1px,
  //     transparent 1px 76px
  //   )
  // `,

  //       backgroundRepeat: "no-repeat",
  //       backgroundPosition: "center -10px, 0 -10px, 0 -10px",
  //     }}
  return (
    <section
      style={{
        backgroundColor: "#fffff",
        backgroundImage: `
    radial-gradient(
      60% 80% at 50% -10%,
      rgba(127, 161, 255, 0.2) 0%,
      rgba(127, 161, 255, 0) 60%
    ),
    url(/assets/hero/grid.svg)
  `,

        backgroundRepeat: "no-repeat",
        backgroundPosition: "center -10px, 0 -10px, 0 -10px",
        // backgroundSize: "contain",
      }}
      className="relative  overflow-hidden px-5 pt-16 backdrop-blur-[6px] sm:px-8 lg:px-20 lg:pt-20"
    >
      {/* ── Headline block ── */}
      <motion.header
        ref={headerRef}
        style={{
          marginBottom: headerMarginBottom,
        }}
        className="relative z-10  mx-auto  flex max-w-[720px] 2xl:max-w-[900px] flex-col items-center justify-center text-center"
      >
        <div className="block absolute top-0 left-0 z-[-1] w-[462px] h-[1000px] bg-zinc-100 rounded-full blur-[107.63px]" />

        <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-black/10 bg-white px-3 py-2 text-xs font-medium text-[#53555C] shadow-sm 3xl:text-sm">
          <span className="inline-flex h-3.5 w-3.5 items-center justify-center rounded-full bg-[#7F7FFF]/20">
            <span className="block h-1.5 w-1.5 rounded-full bg-[#7F7FFF]" />
          </span>
          <span className="whitespace-nowrap font-kalam leading-none">
            Creative Intelligence
          </span>
        </div>

        <h1 className="solution-heading">
          Know Which ad wins <span className="text-[#1F1FCA]">Before</span> you
          spend a dollar.
        </h1>

        <p className="body-secondary-text mt-5 max-w-[580px] 2xl:max-w-[720px] ">
          Imagive&apos;s Creative Intelligence engine scores every creative on
          hook strength, predicts performance against your competitor set, and
          tells you exactly what to change - all before launch.
        </p>

        <div className="mt-8 flex w-full flex-col items-center justify-center gap-3 sm:w-auto sm:flex-row">
          <a
            href="https://app.imagive.ai?redirect=/users/competitive-analysis"
            target="_blank"
            className="btn-primary group inline-flex w-full items-center justify-center gap-2 font-medium sm:w-auto"
          >
            Start Analyse creative
            <ArrowRight
              size={18}
              className="transition-transform duration-300 group-hover:translate-x-1"
            />
          </a>
          <a
            href="https://app.imagive.ai/"
            target="_blank"
            className="btn-secondary group inline-flex w-full items-center justify-center gap-2 font-medium sm:w-auto"
          >
            <Play
              size={16}
              className="transition-transform duration-300 group-hover:scale-110"
            />
            See it in action
          </a>
        </div>
      </motion.header>

      {/* ── Dashboard preview ── */}
      <div
        ref={sectionRef}
        className="relative z-10 mx-auto mt-12 w-full max-w-[1100px] 2xl:max-w-[1400px] lg:mt-1"
        style={{
          perspective: "2000px",
        }}
      >
        <motion.img
          src="/assets/creativeIntelligence/hero.svg"
          alt="Ad Performance Intelligence dashboard"
          width={1008}
          height={618}
          className="h-auto w-full "
          style={{
            rotateX,
            scale,
            y,
          }}
        />
      </div>
    </section>
  );
};

export default HeroSection;
